import { Component } from '@angular/core';

import { SectionTitleComponent } from '../../shared/components/section-title/section-title.component';
import { ProjectBoxComponent } from './project-box/project-box';
import { BtnToContactComponent } from '../../shared/components/btn-to-contact/btn-to-contact.component';
import { MobileSectionTitleComponent } from '../../shared/components/mobile-section-title/mobile-section-title.component';

import { ContentService } from '../../shared/services/content/content.service';
import { ScrollService } from '../../shared/services/scroll/scroll.service';


@Component({
  selector: 'app-my-work',
  imports: [
    SectionTitleComponent,
    ProjectBoxComponent,
    BtnToContactComponent,
    MobileSectionTitleComponent
  ],
  templateUrl: './my-work.component.html',
  styleUrl: './my-work.component.scss',
})
export class MyWorkSection {

  constructor(private scrollService: ScrollService, public contentService: ContentService) { }


  triggerScroll(sectionId: string): void {
    this.scrollService.requestScroll(sectionId);
  }
}